import React, { useEffect, useState } from "react";
import { Button, Col, Input, Label, Modal, Row } from "reactstrap";
import { userService } from "../../../_services/user.service";
import { api } from "../../../_services/api.service";
import { toast } from "react-toastify";

const CopyTemplateModal = ({
  isOpen,
  toggleModal,
  partnerScenarioId,
  reload,
}) => {
  const currentUser = userService.getLoggedInUser();

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  const save = async (includeUsers) => {
    await api.copyPartnerScenario(
      currentUser.userId,
      partnerScenarioId,
      includeUsers
    );
    toggleModal();
    toast.success("Scenario copied");
    reload && reload();
  };

  return (
    <Modal
      isOpen={isOpen}
      size="md"
      toggle={() => {
        toggleModal();
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Copy Template
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal();
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <p>
          This will copy this Template, Edit it from the list to make updates.
          Do you want to copy the users assigned to the template?
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <Button color="primary" size="md" onClick={() => save(true)}>
            Yes - Copy the Users
          </Button>
          <Button color="primary" size="md" onClick={() => save(false)}>
            No - Create the Template without users
          </Button>
        </div>
        <Button color="link" onClick={() => toggleModal()}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default CopyTemplateModal;
